//import _ from 'lodash';

// import VuexPersistence from 'vuex-persist';

export default {
  state: {
    access_token: null,
    access_token_created_at: null,

    user: {},

    user_badges: null,
    user_loading: false,
    environment: null,

    mgm_initiative: null,
    notifications: null,
  },
  mutations: {
    setAccessToken: function(state, access_token){
      state.access_token = access_token;
      state.access_token_created_at = Date.now();
    },

    setUser: function(state, user){
      state.user = user;

      console.log('user', user);

      if( user.environment != undefined)
        state.environment = user.environment;
    },

    updateUser: function(state, user_data){
      state.user = {...state.user, ...user_data};

      if( user_data.environment != undefined)
        state.environment = user_data.environment;

    },

    setUserBadges: function(state, user_badges){
      state.user_badges = user_badges;
    },

    setUserLoading: function(state, user_loading){
      state.user_loading = user_loading;
    },

    setMGMInitiative: function(state, mgm_initiative){
      state.mgm_initiative = mgm_initiative;
    },

    setNotifications: function(state, notifications){
      state.notifications = notifications;
    },

    setEnvironment: function(state, environment){
      state.environment = environment;
    },

  },
  getters: {
    userBadgesCount: function(state){
      var badges_count = null;
      if(state.user_badges){
        badges_count = 0;
        for( var i in state.user_badges){

          console.log('state.user_badges', state.user_badges);
          badges_count += state.user_badges[i].badges;
        }
      }
      console.log('badges_count', badges_count);

      return badges_count;

    }
  },
};
